module.exports = __webpack_public_path__ + "img/icon_xiangmu.1845344d.png";